<div class="checkbox-list">
  <div class="checkbox-list-header">
    <div class="filter-checkbox">
      @if (compData?.containerItem?.title) {
        <div
          class="flex-container ion-align-items-center ion-justify-content-between filter-header">
          <p class="title">{{ compData?.containerItem?.title | titlecase }}</p>
          @if (!isCollapsed) {
            <span class="collapse-icon" (click)="toggleCollapsed();">
              <span class="arrow-down-icon"></span>
            </span>
          }
          @if (isCollapsed) {
            <span class="collapse-icon" (click)="toggleCollapsed();">
              <span class="arrow-up-icon"></span>
            </span>
          }
        </div>
      }
      @if (!isCollapsed) {
        @if (compData?.containerItem?.showSearchBar) {
          <div class="search-bar">
            <input type="text" #searchKey (keyup)="onTextChangeFunc(searchKey?.value)" placeholder="Search">
            <span class="search-icon"></span>
            @if (searchKey?.value) {
              <img class="close-icon"
                   [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/filter-close.webp'"
                   alt="filter-close" (click)="searchKey.value = null; onTextChangeFunc(searchKey.value);"
                   loading="lazy" width="27" height="27">
            }
          </div>
        }
      }
    </div>
  </div>

  @if (!isCollapsed) {
    @for (option of displayOptions | slice:0:limitTo; track option; let i = $index; let l = $last) {
      <div (click)="onItemClickFunc(option, i)"
           class="checkbox-type">
        <div [ngClass]="{ 'selected-checkbox': selectedIds?.indexOf(option?._id + '') > -1 }">
          <div class="checkbox-item">
            <input class="inp-cbx" type="checkbox" [checked]="selectedIds?.indexOf(option?._id + '') > -1">
            <div class="cbx">
              <span>
                <svg width="12px" height="10px" viewbox="0 0 12 10">
                  <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                </svg>
              </span>
              <span class="title-case">{{ option?.title | titlecase }}</span>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="show-link">
      @if (limitTo < compData?.containerItem?.options?.length) {
        <div (click)="onShowAll()">
          <p>Show All+</p>
        </div>
      }
      @if (displayShowLess) {
        <div (click)="onShowLess()">
          <p>Show Less</p>
        </div>
      }
    </div>
  }
</div>

<!--<ion-list class="color-primary" lines="none">
<ion-list-header>
  <div class="w-100">
    <div *ngIf="compData?.containerItem?.title"
      class="flex-container ion-align-items-center ion-justify-content-between">
      <span class="title">{{ compData?.containerItem?.title | titlecase }}</span>
      <ion-icon class="collapse-icon" *ngIf="!isCollapsed" name="chevron-up-outline"
      (click)="toggleCollapsed();"></ion-icon>
      <ion-icon class="collapse-icon" *ngIf="isCollapsed" name="chevron-down-outline"
      (click)="toggleCollapsed();"></ion-icon>
    </div>
    <ng-container *ngIf="!isCollapsed">
      <div class="search-bar" *ngIf="compData?.containerItem?.showSearchBar">
        <ion-searchbar (ionInput)="onTextChangeFunc($event)"></ion-searchbar>
      </div>
    </ng-container>
  </div>
</ion-list-header>
<ng-container *ngIf="!isCollapsed">
  <ion-item
    (click)="onItemClickFunc(option, i)"
    *ngFor="let option of displayOptions | slice:0:limitTo; let i = index; let l = last;"
    class="">
    <ion-label [ngClass]="{ 'font-bold': selectedIds?.indexOf(option?._id + '') > -1 }"
      class=""
    >{{ option?.title | titlecase }}</ion-label>
    <ion-checkbox
      [checked]="selectedIds?.indexOf(option?._id + '') > -1"
      class=""
      name="{{ i }}"
      slot="start">
    </ion-checkbox>
  </ion-item>

  <ion-item class="show-link" *ngIf="limitTo < compData?.containerItem?.options?.length" (click)="onShowAll()">
    <ion-label>
      Show All+
    </ion-label>
  </ion-item>

  <ion-item class="show-link" *ngIf="displayShowLess" (click)="onShowLess()">
    <ion-label>
      Show Less
    </ion-label>
  </ion-item>
</ng-container>
</ion-list>-->
